import React from 'react'
import { useTranslation } from 'react-i18next'
import { BsTrash } from 'react-icons/bs'
import OInputField from 'components/reusable/OInputField'
import OTextArea from 'components/reusable/OTextArea'

const emptyFaq = () => ({
  tempId: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  title: '',
  titleAr: '',
  content: '',
  contentAr: '',
})

const BlogFaqSection = ({ faqs = [], onChange }) => {
  const { t } = useTranslation()

  const updateFaq = (index, field, value) => {
    const next = faqs.map((faq, i) =>
      i === index ? { ...faq, [field]: value } : faq
    )
    onChange(next)
  }

  const addFaq = () => {
    onChange([...faqs, emptyFaq()])
  }

  const removeFaq = (index) => {
    onChange(faqs.filter((_, i) => i !== index))
  }

  return (
    <div className='mt-8 border-t border-stroke pt-6'>
      <div className='flex items-center justify-between mb-4'>
        <h3 className='font-medium text-black dark:text-white text-lg'>
          {t('NAV_FAQS') || 'FAQs'}
        </h3>
        <button
          type='button'
          className='bg-[#8FC150] flex text-sm px-4 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
          onClick={addFaq}
        >
          + {t('FAQS_ADD_FAQS') || 'Add FAQ'}
        </button>
      </div>

      {faqs.length === 0 && (
        <p className='text-sm text-gray-500 mb-4'>
          Click &quot;Add FAQ&quot; to add questions and answers for this blog.
        </p>
      )}

      {faqs.map((faq, index) => (
        <div
          key={faq._id || faq.tempId || index}
          className='mb-5 rounded-lg border border-stroke bg-gray-50 dark:bg-meta-4 p-4 relative'
        >
          <div className='flex items-center justify-between mb-3'>
            <p className='text-sm font-medium text-gray-900 dark:text-white'>
              FAQ {index + 1}
            </p>
            <button
              type='button'
              className='text-red-500 text-lg p-1'
              title='Delete'
              onClick={() => removeFaq(index)}
            >
              <BsTrash />
            </button>
          </div>

          <OInputField
            wrapperClassName='relative z-0 mb-4 w-full group'
            name={`faq-title-${index}`}
            inputLabel={
              <>
                {t('O_TITLE') || 'Question'}
                <span className='text-red-500'>*</span>
              </>
            }
            type='text'
            value={faq.title || ''}
            onChange={(e) => updateFaq(index, 'title', e.target.value)}
          />

          <OInputField
            wrapperClassName='relative z-0 mb-4 w-full group'
            name={`faq-titleAr-${index}`}
            inputLabel={
              <>
                {(t('O_TITLE') || 'Question') + (t('O_ARABIC') || ' (Arabic)')}
                <span className='text-red-500'>*</span>
              </>
            }
            type='text'
            value={faq.titleAr || ''}
            onChange={(e) => updateFaq(index, 'titleAr', e.target.value)}
          />

          <OTextArea
            wrapperClassName='relative z-0 mb-4 w-full group'
            name={`faq-content-${index}`}
            inputLabel={
              <>
                {t('O_ANSWER') || t('STATIC_DESCRIPTION') || 'Answer'}
                <span className='text-red-500'>*</span>
              </>
            }
            value={faq.content || ''}
            onChange={(e) => updateFaq(index, 'content', e.target.value)}
          />

          <OTextArea
            wrapperClassName='relative z-0 w-full group'
            name={`faq-contentAr-${index}`}
            inputLabel={
              <>
                {(t('O_ANSWER') || t('STATIC_DESCRIPTION') || 'Answer') +
                  (t('O_ARABIC') || ' (Arabic)')}
                <span className='text-red-500'>*</span>
              </>
            }
            value={faq.contentAr || ''}
            onChange={(e) => updateFaq(index, 'contentAr', e.target.value)}
          />
        </div>
      ))}
    </div>
  )
}

export default BlogFaqSection
